export default __webpack_public_path__ + "static/giant-4-4c366bb551dc171ff8c0f710dfc5e479.jpg";